import { render } from "./StaffEdit.vue?vue&type=template&id=01d67dd3&ts=true"
import script from "./StaffEdit.vue?vue&type=script&lang=ts"
export * from "./StaffEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__